module.exports = __webpack_public_path__ + "9886f22c6452929bb77b94c954c6c5b4.svg";